/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Command_Center_Or_Settings_Or_ShInputs */

const en_command_center_or_settings_or_sh = /** @type {(inputs: Command_Center_Or_Settings_Or_ShInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command Center | Settings | Shoot Share Connect`)
};

const es_command_center_or_settings_or_sh = /** @type {(inputs: Command_Center_Or_Settings_Or_ShInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de mando | Configuración | Shoot Share Connect`)
};

const fr_command_center_or_settings_or_sh = /** @type {(inputs: Command_Center_Or_Settings_Or_ShInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centre de commandement | Paramètres | Shoot Share Connect`)
};

const de_command_center_or_settings_or_sh = /** @type {(inputs: Command_Center_Or_Settings_Or_ShInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommandozentrale | Einstellungen | Shoot Share Connect`)
};

const ja_command_center_or_settings_or_sh = /** @type {(inputs: Command_Center_Or_Settings_Or_ShInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コマンドセンター | 設定 | Shoot Share Connect`)
};

const zh_command_center_or_settings_or_sh = /** @type {(inputs: Command_Center_Or_Settings_Or_ShInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指挥中心 | 设置 | Shoot Share Connect`)
};

const ar_command_center_or_settings_or_sh = /** @type {(inputs: Command_Center_Or_Settings_Or_ShInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مركز القيادة | الإعدادات | Shoot Share Connect`)
};

const id_command_center_or_settings_or_sh = /** @type {(inputs: Command_Center_Or_Settings_Or_ShInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat Komando | Pengaturan | Shoot Share Connect`)
};

const it_command_center_or_settings_or_sh = /** @type {(inputs: Command_Center_Or_Settings_Or_ShInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro di Comando | Impostazioni | Shoot Share Connect`)
};

const ru_command_center_or_settings_or_sh = /** @type {(inputs: Command_Center_Or_Settings_Or_ShInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Командный центр | Настройки | Shoot Share Connect`)
};

const pt_command_center_or_settings_or_sh = /** @type {(inputs: Command_Center_Or_Settings_Or_ShInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro de Comando | Configurações | Shoot Share Connect`)
};

const ko_command_center_or_settings_or_sh = /** @type {(inputs: Command_Center_Or_Settings_Or_ShInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커맨드 센터 | 설정 | Shoot Share Connect`)
};

/**
* | output |
* | --- |
* | "Command Center \| Settings \| Shoot Share Connect" |
*
* @param {Command_Center_Or_Settings_Or_ShInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const command_center_or_settings_or_sh = /** @type {((inputs?: Command_Center_Or_Settings_Or_ShInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Command_Center_Or_Settings_Or_ShInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_command_center_or_settings_or_sh(inputs)
	if (locale === "es") return es_command_center_or_settings_or_sh(inputs)
	if (locale === "fr") return fr_command_center_or_settings_or_sh(inputs)
	if (locale === "de") return de_command_center_or_settings_or_sh(inputs)
	if (locale === "ja") return ja_command_center_or_settings_or_sh(inputs)
	if (locale === "zh") return zh_command_center_or_settings_or_sh(inputs)
	if (locale === "ar") return ar_command_center_or_settings_or_sh(inputs)
	if (locale === "id") return id_command_center_or_settings_or_sh(inputs)
	if (locale === "it") return it_command_center_or_settings_or_sh(inputs)
	if (locale === "ru") return ru_command_center_or_settings_or_sh(inputs)
	if (locale === "pt") return pt_command_center_or_settings_or_sh(inputs)
	return ko_command_center_or_settings_or_sh(inputs)
});